import {
	GetCapsulePartyByID,
	GetCapsulePartyPeopleByID,
} from "@app/api/CapsuleParties";
import type { CapsuleParty } from "@app/interfaces/CapsuleParty";
import { useQuery } from "@tanstack/react-query";

export const useOrganisation = (capsule_id: string) => {
	const organisation = useQuery({
		queryKey: ["organisation", capsule_id],
		queryFn: () =>
			GetCapsulePartyByID(capsule_id).then((resp) => {
				if (resp == null) {
					return;
				}
				return resp.party;
			}),
	});

	const organisationPeople = useQuery({
		queryKey: ["people", capsule_id],
		queryFn: (): Promise<CapsuleParty[] | null> =>
			GetCapsulePartyPeopleByID(capsule_id).then((resp) => {
				if (resp == null) {
					return null;
				}
				const data = resp.parties;
				if (data == null) {
					return [];
				}
				return data;
			}),
	});

	return {
		organisation,
		organisationPeople,
	};
};
